import { MutationTree } from 'vuex';
import { EmailsMutations, EmailsState } from './types';
import { EmailTemplatePage } from '@mentessa/types';

export const mutations: MutationTree<EmailsState> = {
  [EmailsMutations.SetEmails](state: EmailsState, page: EmailTemplatePage) {
    state.emailsPage = page;
  },
};
